// import '@archetype-themes/scripts/config'
// import Swatches from '@archetype-themes/scripts/modules/swatches'

export default class ProductGridItem extends HTMLElement {
  constructor(container) {
    super()

      this.container = container
    // this.swatches = new Swatches(this)
    this.swapText = this.container.querySelector('[data-text-swap]')
    this.textToBeRemoved = this.swapText?.dataset?.textSwap
    this.productTitle = this.container.querySelector('.grid-product__title')
    /**
     * @event product-grid-item:loaded
     * @description Fires when the product grid item has been loaded.
     */
    document.dispatchEvent(new CustomEvent('product-grid-item:loaded'))

    if(this.textToBeRemoved || this.productTitle) {
      this.updateText()
    }

  }

  updateText() {
    if (!this.textToBeRemoved || !this.productTitle) return;

    // Normalize collection name: remove "The " at start, lowercase, trim
    const normalizedPhrase = this.textToBeRemoved
        .toLowerCase()
        .replace(/^the\s+/i, '')
        .trim();

    if (!normalizedPhrase) return;

    // Build regex to match anywhere in product title (word boundary optional)
    const regex = new RegExp(normalizedPhrase, 'i');
    // Replace matched phrase and clean extra spaces
    const cleanedTitle = this.productTitle.textContent
        .replace(regex, '')
        .replace(/\s{2,}/g, ' ') // collapse multiple spaces
        .trim();

    if (cleanedTitle) {
      this.productTitle.textContent = cleanedTitle;
    }
  }
}

customElements.define('product-grid-item', ProductGridItem)
